import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/app/apps/web/app/sentry/SentryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/apps/web/lingodotdev/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/modules/ui/globals.css");
